/**
 * How was the CURRENT session authenticated?
 *
 * Supabase records this in the access token's `amr` claim (authentication
 * methods reference): a password sign-in gives `{ method: "password" }`, a
 * magic-link / email-OTP sign-in gives `{ method: "otp" }`.
 *
 * VA-192 — Bridget: "the users have a default password Vision2026! and they
 * should be automatically logged in to the dashboard the first time and when
 * they use the magic link. When they return the next time, they will be
 * prompted to create a password."
 *
 * That distinction is per-LOGIN, not per-account, so it cannot be answered by
 * `signup_channel`, which only records how the account was first created.
 *
 * Kept free of any Supabase import so it stays cheap to unit test.
 */
export function signedInWithMagicLink(accessToken: string | undefined): boolean {
  if (!accessToken) return false;
  try {
    const payload = accessToken.split(".")[1];
    if (!payload) return false;
    const padded =
      payload.replace(/-/g, "+").replace(/_/g, "/") +
      "=".repeat((4 - (payload.length % 4)) % 4);
    const claims = JSON.parse(atob(padded)) as {
      amr?: { method?: string; timestamp?: number }[];
    };
    if (!Array.isArray(claims.amr) || claims.amr.length === 0) return false;
    // A session can accumulate methods; the most recent one is how they got in.
    const latest = claims.amr.reduce((a, b) =>
      (b.timestamp ?? 0) >= (a.timestamp ?? 0) ? b : a
    );
    return latest.method === "otp" || latest.method === "magiclink";
  } catch {
    // Fail closed: an unreadable token falls back to the normal profile check
    // rather than silently skipping a prompt someone should have seen.
    return false;
  }
}
